<pdq-card variant="popover" color="white">
  <div class="container">
    <div class="header">
      <pdq-heading element="h3" capitalized="true">Choose a payment method</pdq-heading>
    </div>
    <pdq-divider></pdq-divider>
    <div class="content body-14-regular">
      <p>
        Select how you'd like to pay for this plan. You can change this later in Settings &gt; Billing &gt; Overview.
      </p>
      <div class="options">
        <pdq-button
          variant="primary"
          size="large"
          label="Credit card"
          [fullWidth]="true"
          (onClick)="choose('card')"></pdq-button>
        <pdq-button
          variant="light"
          size="large"
          label="ACH bank account"
          [fullWidth]="true"
          (onClick)="choose('ach')"></pdq-button>
      </div>
    </div>
    <pdq-divider></pdq-divider>
    <footer>
      <pdq-button variant="tertiary" label="Cancel" (onClick)="cancel()"></pdq-button>
    </footer>
  </div>
</pdq-card>
